import {
  Button as MantineButton,
  type ButtonProps as MantineButtonProps,
} from "@mantine/core";
import type { CoreComponentProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type ButtonProps = CoreComponentProps<MantineButtonProps, 'button'>;

export function Button({ testId, view = "all", ...rest }: ButtonProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineButton data-testid={testId} {...rest} />;
}
